import { observable } from "micro-observables";
import { BaseExercise } from "@domain/exercise/exercise";
import { orderList } from "@utils/string-utils";

export class ExerciseSelectionManager {
    protected readonly _selectedExercises = observable<BaseExercise[]>([]);
    public readonly selectedExercises = this._selectedExercises.readOnly();

    clearAllSelectedExercises(): void {
        this._selectedExercises.set([]);
    }

    updateSelectedExerciseList(exercises: BaseExercise[], isSelected: boolean): void {
        for (const exercise of exercises) {
            this.updateSelectedExercise(exercise, isSelected);
        }
    }

    updateSelectedExercise(exercise: BaseExercise, isSelected: boolean): void {
        const selectedExercises = [...this._selectedExercises.get()];
        if (isSelected) {
            this._selectedExercises.set(orderList([...selectedExercises, exercise], "title"));
        } else {
            selectedExercises.splice(selectedExercises.indexOf(exercise), 1);
            this._selectedExercises.set(selectedExercises);
        }
    }
}